import React from 'react'

import Modal from '../../common/components/Modal'

const DeleteModal = props => {
  const { onClose, onDelete } = props
  return <Modal
    cancelModal={onClose}
    saveAction={<button className="btn btn-danger" onClick={onDelete}>
      <i className="fa fa-trash-can" /> Delete
    </button>}>
    <Modal.Header>
      Delete User
    </Modal.Header>
    <Modal.Body>
      <div className="alert alert-danger">
        <h4>This will permanantly delete the user.</h4>
        <p>This action cannot be undone!</p>
      </div>
    </Modal.Body>
    <Modal.Footer />
  </Modal>
}

export default DeleteModal
